import React from 'react';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import {Asset} from '@deviceinsight/ng-ui-api-client';
import {SpinnerContainer} from '@deviceinsight/ng-ui-basic-components';
import AssetInfoBlock from './AssetInfoBlock';
import FirmwareAssetInfo from './blocks/FirmwareAssetInfo';
import useAssetInfoData from './hooks/useAssetInfoData';
import {InfoType} from './types';
import {ASSET_TYPE_PROPERTY} from '../../../../modules/ruleengine/config/consts';
import {
	DATAPOINT_APPLICATION_VERSION,
	DATAPOINT_BOOTLOADER_VERSION,
	DATAPOINT_CERTIFICATE_EXPIRATION,
	DATAPOINT_DATA_MATRIX_CODE,
	DATAPOINT_FIRMWARE_VERSION,
	DATAPOINT_GATEWAY,
	DATAPOINT_HARDWARE_REVISION,
	DATAPOINT_IP_ADRESS,
	DATAPOINT_MAC_ADRESS,
	DATAPOINT_OPEN_SSL_VERSION,
	DATAPOINT_OS_VERSION,
	DATAPOINT_PART_NUMBER,
	DATAPOINT_SERIAL_NUMBER,
	DATAPOINT_SUBNET,
	DATAPOINT_WIFI_CHANNEL,
	DATAPOINT_WIFI_SIGNAL_STRENGTH,
	DATAPOINT_WIFI_SSID
} from '../../../../modules/common/consts';
import './AssetInfo.less';
import {ASSET_INFO_TEST_IDS} from './consts';
type Props = {
	asset: Asset;
};
const HARDWARE_DATAPOINTS = [
	DATAPOINT_PART_NUMBER,
	DATAPOINT_SERIAL_NUMBER,
	DATAPOINT_DATA_MATRIX_CODE,
	DATAPOINT_MAC_ADRESS,
	DATAPOINT_HARDWARE_REVISION
];
const SOFTWARE_DATAPOINTS = [
	DATAPOINT_OS_VERSION,
	DATAPOINT_APPLICATION_VERSION,
	DATAPOINT_FIRMWARE_VERSION,
	DATAPOINT_BOOTLOADER_VERSION,
	DATAPOINT_OPEN_SSL_VERSION
];
const NETWORK_DATAPOINTS = [
	DATAPOINT_WIFI_SSID,
	DATAPOINT_WIFI_SIGNAL_STRENGTH,
	DATAPOINT_WIFI_CHANNEL,
	DATAPOINT_IP_ADRESS,
	DATAPOINT_SUBNET,
	DATAPOINT_GATEWAY
];
const CERTIFICATE_DATAPOINTS = [DATAPOINT_CERTIFICATE_EXPIRATION];

const AssetInfo = ({asset}: Props) => {
	const {assetData, loading} = useAssetInfoData(asset);
	const assetType = asset.properties[ASSET_TYPE_PROPERTY];
	return (
		<div>
			<h1 className="di header">
				<Trans i18nKey="rafi.assetinfo.title">Device Information</Trans>
			</h1>
			<SpinnerContainer show={loading} size={50}>
				<div className="asset-info" data-testid={ASSET_INFO_TEST_IDS.ASSET_INFO}>
					<div className="col">
						<AssetInfoBlock
							type={InfoType.HARDWARE}
							datapoints={HARDWARE_DATAPOINTS}
							assetData={assetData}
							assetType={assetType}
						/>
						<AssetInfoBlock
							type={InfoType.SOFTWARE}
							datapoints={SOFTWARE_DATAPOINTS}
							assetData={assetData}
						/>
						<AssetInfoBlock
							type={InfoType.CERTIFICATE}
							datapoints={CERTIFICATE_DATAPOINTS}
							assetData={assetData}
						/>
					</div>
					<div className="col">
						<AssetInfoBlock type={InfoType.NETWORK} datapoints={NETWORK_DATAPOINTS} assetData={assetData} />
						<FirmwareAssetInfo assetData={assetData} />
					</div>
				</div>
			</SpinnerContainer>
		</div>
	);
};

export default AssetInfo;
